export type OverallFeedback = 'positivo' | 'neutro' | 'negativo'

/** Modo de destino no formulário (não persiste no banco). */
export type ActivityDestinationKind = 'broker' | 'custom'

export interface ComercialActivity {
  id: string
  commercial_responsible_user_id: string
  commercial_responsible_name: string
  activity_date: string
  broker_id: string | null
  visited_location: string | null
  activity_type_id: string
  visit_objective_id: string
  overall_feedback: OverallFeedback
  general_perceptions: string
  created_at: string
  updated_at: string
  deleted_at?: string | null
  broker?: { id: string; name: string; id_scgp: number | null } | null
  activity_type?: { id: string; name: string }
  visit_objective?: { id: string; name: string }
}

export interface ComercialActivityInput {
  activity_date: string
  broker_id: string | null
  visited_location: string | null
  activity_type_id: string
  visit_objective_id: string
  overall_feedback: OverallFeedback
  general_perceptions: string
}

export interface ComercialActivityResponsible {
  userId: string
  name: string
}

export const FEEDBACK_LABELS: Record<OverallFeedback, string> = {
  positivo: 'Positivo',
  neutro: 'Neutro',
  negativo: 'Negativo',
}

export const FEEDBACK_BADGE_CLASS: Record<OverallFeedback, string> = {
  positivo: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200',
  neutro: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
  negativo: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
}
